import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'referrals',
    viewPath: props.viewPath,
  })

  let referral_index = useDataValue({
    context: 'referral_item',
    viewPath: props.viewPath,
    path: 'index',
  })

  return () => {
    submit({
      type: 'clear_person',
      index: referral_index,
    })
  }
}
